import FormValidation from '@plone/volto/helpers/FormValidation/FormValidation';
import config from '@plone/volto/registry';

/**
 * Valida blocos do tipo tabs e seus filhos recursivamente.
 * Retorna erros no formato { [blockId]: erros }.
 */
export function validateTabsBlock({ schema, formData, formatMessage }) {
  if (!formData || formData['@type'] !== 'tabs_block') return {};
  const errors = {};
  validateTabsBlockRecursive({
    block: formData,
    schema,
    formatMessage,
    errors,
    blockId: formData.id || formData['@id'] || 'tabs_block',
  });
  return errors;
}

function validateTabsBlockRecursive({
  block,
  schema,
  formatMessage,
  errors,
  blockId,
}) {
  if (!block) return;

  // Se for tabs, valida os painéis (blocks)
  if (block['@type'] === 'tabs_block' || block['@type'] === 'tab') {
    const children = getTabsChildren(block);
    children.forEach(({ childBlock, childId }) => {
      if (!childBlock) return;
      // Se for container de blocos (painel), desce mais um nível
      if (
        !childBlock['@type'] &&
        childBlock.blocks &&
        childBlock.blocks_layout
      ) {
        getTabsChildren(childBlock).forEach(
          ({ childBlock: grandChild, childId: grandChildId }) => {
            if (grandChild) {
              const grandChildSchema = getBlockSchema(grandChild, {
                formatMessage,
              });
              validateTabsBlockRecursive({
                block: grandChild,
                schema: grandChildSchema,
                formatMessage,
                errors,
                blockId: grandChildId,
              });
            }
          },
        );
      } else {
        // Se já é um bloco de conteúdo ou outro tabs
        const childSchema = getBlockSchema(childBlock, { formatMessage });
        validateTabsBlockRecursive({
          block: childBlock,
          schema: childSchema,
          formatMessage,
          errors,
          blockId: childId,
        });
      }
    });
  } else if (block['@type']) {
    // Valida blocos de conteúdo (teaser, slate, etc)
    const validationErrors = FormValidation.validateFieldsPerFieldset({
      schema: schema || getBlockSchema(block, { formatMessage }),
      formData: block,
      formatMessage,
    });
    if (Object.keys(validationErrors).length > 0) {
      errors[blockId] = validationErrors;
    }
  }
}

/**
 * Retorna os filhos de um bloco tabs (blocks + blocks_layout).
 */
function getTabsChildren(block) {
  const data = block.data || block;
  const blocks = data.blocks;
  const blocksLayout = data.blocks_layout;
  if (!blocks || !blocksLayout) return [];

  return blocksLayout.items.map((childId) => ({
    childBlock: blocks[childId],
    childId,
  }));
}

/**
 * Recupera o schema do bloco.
 */
function getBlockSchema(blockFormData, intl) {
  const defaultSchema = {
    properties: {},
    fieldsets: [],
    required: [],
  };
  const blockType = blockFormData['@type'];
  const blockSchema =
    config.blocks.blocksConfig[blockType]?.blockSchema || defaultSchema;

  return typeof blockSchema === 'function'
    ? blockSchema({ intl, formData: blockFormData })
    : blockSchema;
}
